"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSampleProjectArguments = exports.CreateSampleProjectOptions = void 0;
exports.CreateSampleProjectOptions = [
    {
        name: "folder",
        type: "string",
        shortName: "f",
        description: "Directory where the project folder will be created in.",
        required: true,
        default: "./",
    },
];
exports.CreateSampleProjectArguments = [
    {
        name: "sample-name",
        questionName: "samples",
        type: "string",
        description: "Specifies the Microsoft Teams App sample name.",
        required: true,
        choices: [
            "hello-world-tab-with-backend",
            "graph-toolkit-contact-exporter",
            "bot-sso",
            "todo-list-SPFx",
            "hello-world-in-meeting",
            "todo-list-with-Azure-backend-M365",
            "NPM-search-connector-M365",
            "bot-proactive-messaging-teamsfx",
            "adaptive-card-notification",
            "incoming-webhook-notification",
            "stocks-update-notification-bot",
            "query-org-user-with-message-extension-sso",
            "team-central-dashboard",
            "graph-connector-app",
            "graph-toolkit-one-productivity-hub",
            "todo-list-with-Azure-backend",
            "share-now",
            "hello-world-teams-tab-and-outlook-add-in",
            "outlook-add-in-set-signature",
            "developer-assist-dashboard",
            "live-share-dice-roller",
            "teams-chef-bot",
            "spfx-productivity-dashboard",
            "react-retail-dashboard",
            "sso-enabled-tab-via-apim-proxy",
            "large-scale-notification",
            "graph-connector-bot",
        ],
        choiceListCommand: "teamsapp list samples",
        skipValidation: true,
    },
];
//# sourceMappingURL=CreateSampleProjectOptions.js.map